const movieSortOptions = [
  {
    label: '按时间排序',
    value: 'releaseDate'
  },
  {
    label: '按票房排序',
    value: 'movieBoxOffice'
  },
  {
    label: '按时长排序',
    value: 'movieLength'
  }
];

const DEFAULT_MOVIE_SORT = 'releaseDate';
const DEFAULT_MOVIE_SORT_DIRECTION = 'desc';

module.exports = {
  movieSortOptions,
  DEFAULT_MOVIE_SORT,
  DEFAULT_MOVIE_SORT_DIRECTION
};
